import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/PUFMKBcRwVIwZeuzhMwL/locations/P1BGksqMg24aGrp76vGF`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="80%"
                  minWidth="250px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/PUFMKBcRwVIwZeuzhMwL/locations/P1BGksqMg24aGrp76vGF`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="28vw"
                  maxWidth="400px"
                  alt="About"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
